import { TimePicker } from "../../../../ui/atoms/TimePicker";

interface TimeInputsProps {
  readonly startTime: string;
  readonly onStartTimeChange: (time: string) => void;
  readonly endTime: string;
  readonly onEndTimeChange: (time: string) => void;
}

export function TimeInputs({
  startTime,
  onStartTimeChange,
  endTime,
  onEndTimeChange,
}: TimeInputsProps) {
  return (
    <div className="grid grid-cols-2 gap-2">
      <div>
        <label className="block text-[10px] font-medium text-ink-faint uppercase tracking-wide mb-1">
          Début
        </label>
        <TimePicker value={startTime} onChange={onStartTimeChange} />
      </div>
      <div>
        <label className="block text-[10px] font-medium text-ink-faint uppercase tracking-wide mb-1">
          Fin
        </label>
        <TimePicker value={endTime} onChange={onEndTimeChange} />
      </div>
    </div>
  );
}
